<template>
  <div class="create-button">
    <slot :on="init" :loading="loading">
      <v-btn @click.stop="init" rounded depressed color="primary">
        {{ $t("Créer") }}
      </v-btn>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    entity: {
      type: Object,
      required: false,
      default: null
    },
    tmpEntity: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    formEntity() {
      return null;
    }
  },
  methods: {
    async init() {
      return await this.setItem();
    },
    async setItem() {
      if (this.entity != null) {
        this.loading = true;

        let entity = await this.populateEntity(this.entity.id);

        if (this.tmpEntity) {
          this.formEntity = Object.assign({}, entity);
        } else {
          this.formEntity = Object.assign({}, this.entity);
        }
        setTimeout(() => {
          this.loading = false;
          this.openDrawer();
        }, 200);
      } else {
        this.resetForm();
        setTimeout(this.openDrawer);
      }
    },
    openDrawer() {
      // eslint-disable-next-line no-console
      console.error("This function must be implemented.");
    },
    populateEntity() {
      // eslint-disable-next-line no-console
      console.error("This function must be implemented.");
    },
    resetForm() {
      // eslint-disable-next-line no-console
      console.error("This function must be implemented.");
    }
  }
};
</script>

<style lang="scss">
.create-button-drawer {
  text-align: left;
}

.slide-from-right-enter,
.slide-from-right-leave-to {
  transform: translateX(100%) !important;
}
</style>
